export const METAOS_APP_ID = "69e1409d-f9f8-4199-98e1-654df1626537"; // FYI same as the 1P app registration of our app, which was not intentional
export const METAOS_TEAMS_URL =
  "https://teams.microsoft.com/l/app/69e1409d-f9f8-4199-98e1-654df1626537?tenantId=72f988bf-86f1-41af-91ab-2d7cd011db47";

export const BIZCHAT_METAOS_APP_ID = "b5abf2ae-c16b-4310-8f8a-d3bcdb52f162";
export const BIZCHAT_METAOS_PAGE_ID =
  "entity1-d870f6cd-4aa5-4d42-9626-ab690c041429";
